import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="relative max-w-6xl mx-auto">
          {/* Decorative line art */}
          <div className="absolute -top-10 -left-6 md:-left-10 text-accent-200 opacity-30 select-none pointer-events-none">
            <i className="ri-leaf-line text-8xl md:text-9xl"></i>
          </div>

          {/* Main Card */}
          <div className="relative bg-foreground-950 rounded-2xl md:rounded-3xl overflow-visible">
            <div className="flex flex-col md:flex-row">
              {/* Portrait */}
              <div className="relative w-full md:w-[35%] lg:w-[30%] shrink-0">
                <div className="h-64 md:h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle%20eastern%20factory%20owner%20in%20his%2050s%20wearing%20a%20crisp%20white%20shirt%20standing%20in%20a%20modern%20textile%20factory%2C%20warm%20industrial%20lighting%2C%20confident%20expression%2C%20clean%20background%20with%20soft%20bokeh%2C%20professional%20editorial%20photography%2C%20natural%20warm%20tones&width=600&height=800&seq=testimonial-portrait&orientation=portrait"
                    alt="Ahmed Al-Rashid - CEO"
                    className="w-full h-full object-cover object-center md:rounded-l-3xl"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col justify-center p-6 md:p-10 lg:p-14">
                {/* Quotation mark */}
                <span className="text-6xl md:text-7xl font-serif text-accent-300/40 leading-none select-none mb-4">
                  &ldquo;
                </span>

                <blockquote className="text-sm md:text-base lg:text-lg text-background-50/90 leading-relaxed mb-6 md:mb-8 font-light">
                  {t('testimonial.quote')}
                </blockquote>

                {/* Author */}
                <div className="mb-5 md:mb-6">
                  <p className="text-sm md:text-base font-semibold text-background-50">
                    {t('testimonial.name')}
                  </p>
                  <p className="text-xs md:text-sm text-background-50/50 mt-0.5">
                    {t('testimonial.role')}
                  </p>
                </div>

                {/* CTA */}
                <a
                  href="/about"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold transition-colors duration-200 cursor-pointer w-fit whitespace-nowrap"
                >
                  {t('testimonial.cta')}
                  <i className="ri-arrow-right-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}